import posthog from "posthog-js";

posthog.init("phc_gCtw6r9Ungn88XlIevnlIOh6JEvXH8gweR2JDqBzWcj", {
  api_host: "https://eu.i.posthog.com",
  defaults: "2025-05-24",
});
